module.exports = __webpack_public_path__ + "img/ico-up.194051af.svg";